export default "__VITE_ASSET__BSZuGRl2__"